module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "210%",
      "margin-top": "10%"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/contents#toc1",
      "id": "toc1a"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "noindent",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("I WISH TO EXPRESS")]), _vm._v(" my gratitude to Dr. Egbert Asshauer, Michel Bitbol, and Alan Wallace for fruitful discussion and criticism. The photos in the book come with permission from the personal archives of Carey Linde, Matthieu Ricard, Pier Luigi Luisi, and the Mind and Life Institute. Thanks are also due to Angelo Merante at the University of Rome 3 for the photo editing. Scientific illustrations are taken either from the Internet, with modifications; or from the book by P. L. Luisi, "), _c('i', [_vm._v("The Emergence of Life, from Chemical Origins to Synthetic Biology")]), _vm._v(" (New York: Cambridge University Press, 2006), with modifications.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-778935c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 75
// module chunks = 0